export default __webpack_public_path__ + "static/media/logo.17994cb9.png";